export default __webpack_public_path__ + "media/images/logo-footer-dark-2ebf108a840f9f5f586b44705bd7420c.png";